import youtube_logo from '../../../img/youtube.png';
import Youtube from '../../widgets/youtube/youtube';

export default function SouthDronographer(props) {

    const lang = props.lang;

    const text_es = "En este artículo les comparto mi canal de videos hechos con mi drone. Te invito a disfrutarlos.";
    const text_en = "In this article I share my channel with drone made videos. I invite you to enjoy them.";

    let text = text_es;
    switch(lang){
        case "en":
            text = text_en;
        default:
            break;
    }


    return (
        <div>
            <p>{text}</p>
        <article className='article' name='dronographer'><img src={youtube_logo} width="32px" alt="youtube"/>
            <Youtube channelId={process.env.REACT_APP_DRONOGRAPHER_CHANNEL_ID} 
            apiKey={process.env.REACT_APP_YOUTUBE_API_KEY} random="yes" title="South Dronographer"/>
        </article>
</div>);
}
